export default {"src":"/_next/static/media/external_link.ee019df4.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};